import React from 'react';
import { Layout, Typography } from 'antd';
import useHeaderStyles from 'jss/HeaderStyles';
import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import { useHistory } from 'react-router-dom';
import useWindowDimensions from 'data/useWindowDimensions';

const Header = props => {
  const { Header } = Layout;
  const { Title } = Typography;
  const { width } = useWindowDimensions();
  const classes = useHeaderStyles({ width });
  const history = useHistory();

  return (
    <Header className={classes.headerContainer}>
      {/* <div className={classes.logoContainer}></div> */}
      <div className={classes.subHeaderContainer}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {props.canGoBack && (
            <ArrowLeftOutlined
              style={{ fontSize: 20, marginRight: 10 }}
              onClick={() => history.goBack()}
            />
          )}
          <Title level={4} style={{ marginBottom: 0 }}>
            {props.title}
          </Title>
        </div>
      </div>
    </Header>
  );
};

export default Header;
